import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import type { Response } from './types'
import { GetTemplesResponse, Temple, TemplePayload } from './types/templeTypes'

class TempleApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  createTemple = (payload: TemplePayload) =>
    this.api.post<Response<any>>('/gw2/puja/internal/v1/temples', payload)

  updateTemple = (templeId: string, payload: TemplePayload) =>
    this.api.put<Response<any>>(
      `/gw2/puja/internal/v1/temples/${templeId}`,
      payload,
    )

  getTemples = (params: any, verbose = true) => {
    if (typeof params === 'object') {
      return this.api.get<Response<GetTemplesResponse>>(
        '/gw2/puja/internal/v1/temples',
        { params },
      )
    }
    return this.api.get<Response<GetTemplesResponse>>(
      `/gw2/puja/internal/v1/temples?title=${params}&verbose=${verbose}`,
    )
  }

  getTempleById = (templeId: string) =>
    this.api.get<Response<Temple>>(`/gw2/puja/internal/v1/temples/${templeId}`)
}

export default TempleApi
